var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataReady)?_c('donut',{key:_vm.dataReady,attrs:{"series":_vm.series,"labels":_vm.seriesLabels,"chartOptions":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }